import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagName } from '../../global/transform-tag-name';
import { DEFAULT_WORKBENCH_THEME, WorkbenchTheme } from '../../shared/themes';

/**
 * @slot - button placed within the element
 */
@Component({
  tag: 'wb-load-more',
  styleUrl: 'load-more.scss',
  shadow: true,
})
export class LoadMoreComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /** the colour scheme */
  @Prop({ reflect: true })
  public theme: WorkbenchTheme = DEFAULT_WORKBENCH_THEME;

  /** currently active page (starts with 1 for first page) */
  @Prop()
  public currentPage: number = 1;

  /** number of available pages */
  @Prop()
  public pages?: number;

  private WbText: string;
  private WbProgress: string;

  public connectedCallback(): void {
    this.WbText = transformTagName('wb-text', 'wb-load-more', this.el);
    this.WbProgress = transformTagName('wb-progress', 'wb-load-more', this.el);
  }

  public render(): JSX.Element {
    const { WbText, WbProgress } = this;

    return (
      <Host class="wb-load-more">
        <WbText size="m" static>
          {Math.min(this.currentPage, this.pages)} / {this.pages}
        </WbText>
        <WbProgress value={(this.currentPage / this.pages) * 100} rounded theme={this.theme} progressAriaLabel={null} />
        <slot />
      </Host>
    );
  }
}
